import React from "react";
import MovementForm from "../../../components/user/movement/movementForm";
import Layout from "../../../components/layouts/verticalLayout";

const NewMovementPage = () => {
  return (
    <Layout
      body={
        <>
          <MovementForm />
        </>
      }
    />
  );
};

NewMovementPage.propTypes = {};

export default NewMovementPage;
